export const REGISTRATION = 'REGISTRATION';
export const LOGIN = 'LOGIN';
export const WELCOME = 'WELCOME';
export const RECORD_TEST = 'RECORD_TEST';
export const END_OF_TIME = 'END_OF_TIME';
export const THANK_YOU = 'THANK_YOU';
export const PRIVACY_POLICY = 'PRIVACY_POLICY';
export const COOKIES_POLICY = 'COOKIES_POLICY';
